import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { antiRaidApi } from "../http/Api";

export const getAntiRaid = createAsyncThunk(
  "AntiRaid/getAntiRaid",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiRaidApi.getAntiRaid(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiRaidSlice.actions.setAntiRaid(response));
    }
  }
);

export const getAntiRaidAdvanced = createAsyncThunk(
  "AntiRaid/getAntiRaidAdvanced",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiRaidApi.getAntiRaidAdvanced(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiRaidSlice.actions.setAntiRaidAdvanced(response));
    }
  }
);

export const getAntiRaidLogs = createAsyncThunk(
  "AntiRaid/getAntiRaidLogs",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await antiRaidApi.getLogs(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(antiRaidSlice.actions.setAntiRaidLogs(response));
    }
  }
);

const initialState = {
  antiRaidGlobalState: null,
  antiRaidAdvancedGlobalState: null,
  antiRaidLogsState: null,
};

const antiRaidSlice = createSlice({
  name: "antiRaid",
  initialState,
  reducers: {
    setAntiRaid: (state, action) => {
      state.antiRaidGlobalState = action.payload;
    },
    setAntiRaidAdvanced: (state, action) => {
      state.antiRaidAdvancedGlobalState = action.payload;
    },
    setAntiRaidLogs: (state, action) => {
      state.antiRaidLogsState = action.payload;
    },
  },
});

export const antiRaid = antiRaidSlice.reducer;
